import type { Component, Entity2D } from '../../odie';

import { ColorId, ColorsBlockOptionDef, SirenBlockProps } from '../defs/block';
import { SirenBlockView, SirenKey } from '../views/blocks/SirenBlockView';

// types
//-----------------------------------------------------------------------------
export type SirenBlockComponentOptions = {
  props: SirenBlockProps;
  option?: number;
};

/*
    siren block component
*/
export class SirenBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockSiren';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: SirenBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: SirenBlockComponentOptions): void {
    // get option def
    const optionDef = (options.props.options?.[options.option || 0] ??
      options.props.options?.[0]) as ColorsBlockOptionDef;

    // create container
    this.view = new SirenBlockView(options.props);

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();

    // We check if the option is less than 10000 because if it's higher it's an encoded gameplay state.
    // If it's less than 10, it's an option index.
    // TODO: Find a better way of doing this.
    if (!options.option || options.option < 10000) {
      for (let i = 0; i < optionDef.colors.length; i++) {
        const color = optionDef.colors[i];
        this.view.enable(i as SirenKey, color);
      }
    } else {
      this.view.setGameplayState(options.option);
    }
  }

  // api
  //-------------------------------------------------------------------------
  public isEmpty(): boolean {
    return this.view.isEmpty();
  }

  public poke(color: ColorId) {
    // disable specified color
    return this.view.disableColor(color);
  }

  public getGameplayState() {
    return this.view.getGameplayState();
  }
}
